import React from "react";

export default function Phq2Form({ phq2, onChange, isEditing=true }) {
  const set = (k, v) => onChange({ ...phq2, [k]: v });

  return (
    <div className="cn-card">
      <h3>🧠 PHQ-2</h3>
      <div className="row">
        <div>
          <label>
            <span style={{ marginRight: 8 }}>😔</span>
            1. Little interest or pleasure in doing things
          </label>
          <select value={phq2.PHQ9_1_1 || 0} onChange={(e) => set("PHQ9_1_1", Number(e.target.value))} disabled={!isEditing}>
            <option value={0}>Not at all</option>
            <option value={1}>Several days</option>
            <option value={2}>More than half the days</option>
            <option value={3}>Nearly every day</option>
          </select>
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>😞</span>
            2. Feeling down, depressed, or hopeless
          </label>
          <select value={phq2.PHQ9_2_1 || 0} onChange={(e) => set("PHQ9_2_1", Number(e.target.value))} disabled={!isEditing}>
            <option value={0}>Not at all</option>
            <option value={1}>Several days</option>
            <option value={2}>More than half the days</option>
            <option value={3}>Nearly every day</option>
          </select>
        </div>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>✅</span>
            <input 
              type="checkbox" 
              checked={phq2.PHQ9scorereviewed || false}
              onChange={(e) => set("PHQ9scorereviewed", e.target.checked ? 1 : 0)} 
              disabled={!isEditing}
            />
            PHQ-9 score reviewed
          </label>
        </div>
      </div>
    </div>
  );
}